module.exports = __webpack_public_path__ + "static/img/hero-fit-gold.70deb58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero-fit-gold.png
// module id = 1089
// module chunks = 173